import { Navigate, type RouteObject } from 'react-router-dom';
import userRoutes from './users/routes';
import tenantRoutes from './tenants/routes';
import dataImportRoutes from './dataImport/routes';
import syncHistoryRoutes from './syncHistory/routes';
import AdminPage from './pages/AdminPage';

const routes: RouteObject[] = [
  {
    index: true,
    element: <Navigate to="tenants" replace />,
  },
  {
    path: 'users',
    children: userRoutes,
  },
  {
    path: 'tenants',
    children: tenantRoutes,
  },
  {
    path: 'model-library',
    element: <AdminPage tab="model-library" />,
  },
  {
    path: 'data-import',
    children: dataImportRoutes,
  },
  {
    path: 'sync-history',
    children: syncHistoryRoutes,
  },
];

export default routes;
